
import { useYouTubePlayOnView } from './usePlayOnView';
import './VideoSection.scss';
import { Link } from 'react-router-dom';
import ImageComponent from '../../ImageComponent';
import { SvgIcontWhatsup } from '../../svgs';

const VideoSection = () => {
    const iframeRef = useYouTubePlayOnView();
    return (
        <div className="video-section-bg">
            <div className="video-section-inner" style={{ flexDirection: 'column', alignItems: 'center' }}>
                <h2 id="headTitle">
                  <span id="title1">Project Highlights</span>
                </h2>
                <iframe
                    ref={iframeRef}
                    src="https://www.youtube.com/embed/c8YJsqRNcok?enablejsapi=1&autoplay=0&mute=1&loop=1&playlist=c8YJsqRNcok&controls=0&showinfo=0&modestbranding=1&rel=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    style={{ pointerEvents: 'none' }}
                ></iframe>
                <div className='video-description'>
                    <p className='textCenter taleText'>Our work speaks for itself. This video showcases the precision and quality we bring to every project, highlighting key stages of our work on-site and the successful results we achieve for our clients. See firsthand how our expertise translates into reliable, efficient, and safe systems.</p>
                    <Link className="ctaButton" to="https://wa.me/9347969458?text=Hi%20E%20and%20I%20Engineers,%20I%20would%20like%20to%20learn%20more%20about%20your%20services"><ImageComponent SvgIcon={SvgIcontWhatsup} width="28px" height="28px" />Talk to an Expert</Link>
                </div>

                
            </div>
        </div>
    );
};

export default VideoSection;
